export default __webpack_public_path__ + "static/media/file_green.93c8bc87.svg";